import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NxContactComponent } from './nx-contact.component';
import { FlexLayoutModule } from '@angular/flex-layout';



@NgModule({
  declarations: [
    NxContactComponent
  ],
  imports: [
    CommonModule,
    FlexLayoutModule
  ],
  exports: [
    NxContactComponent
  ]
})
export class NxContactModule { }
